import React from 'react';

// @import components
import SimpleBoxLoader from 'app_components/commons/loaderSkeletons/simpleBoxLoader';
// @end

const AcademicOfferModuleSkeleton = () => {
  return (
    <React.Fragment>
      <div className='row'>
        <div className='col-md-4 col-lg-3 mb-3'>
          <div className='mb-2'>
            <SimpleBoxLoader width='100%' height='6rem' animationSpeed={1} borderRadius='30px' />
          </div>
          <div className='mb-1'>
            <SimpleBoxLoader width='100%' height='2rem' animationSpeed={1} borderRadius='0.25rem' />
          </div>
          <div className='mb-1'>
            <SimpleBoxLoader width='100%' height='2rem' animationSpeed={1} borderRadius='0.25rem' />
          </div>
          <div className='mb-1'>
            <SimpleBoxLoader width='100%' height='2rem' animationSpeed={1} borderRadius='0.25rem' />
          </div>
        </div>
        <div className='col-md-4 col-lg-3 mb-3'>
          <div className='mb-2'>
            <SimpleBoxLoader width='100%' height='6rem' animationSpeed={1} borderRadius='30px' />
          </div>
          <div className='mb-1'>
            <SimpleBoxLoader width='100%' height='2rem' animationSpeed={1} borderRadius='0.25rem' />
          </div>
          <div className='mb-1'>
            <SimpleBoxLoader width='100%' height='2rem' animationSpeed={1} borderRadius='0.25rem' />
          </div>
          <div className='mb-1'>
            <SimpleBoxLoader width='100%' height='2rem' animationSpeed={1} borderRadius='0.25rem' />
          </div>
        </div>
        <div className='col-md-4 col-lg-3 mb-3'>
          <div className='mb-2'>
            <SimpleBoxLoader width='100%' height='6rem' animationSpeed={1} borderRadius='30px' />
          </div>
          <div className='mb-1'>
            <SimpleBoxLoader width='100%' height='2rem' animationSpeed={1} borderRadius='0.25rem' />
          </div>
          <div className='mb-1'>
            <SimpleBoxLoader width='100%' height='2rem' animationSpeed={1} borderRadius='0.25rem' />
          </div>
          <div className='mb-1'>
            <SimpleBoxLoader width='100%' height='2rem' animationSpeed={1} borderRadius='0.25rem' />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AcademicOfferModuleSkeleton;
